export default __webpack_public_path__ + "static/logo@1x-952d5dd6d330c95a3c9ac2c7418131d8.png";